import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EComparaisonLQ } from 'src/app/domain/enum/comparaison-lq';
import { Test } from 'src/app/domain/test';
import { TestService } from 'src/app/services/test.service';
import { StringConverter } from '../string-converter';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-test-available-for-product-box',
    templateUrl: './test-available-for-product-box.html',
    styleUrl: './test-available-for-product-box.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule, MatButtonModule, PreventDoubleClickDirective]
})
export class TestAvailableForProductBoxComponent implements OnInit, AfterContentInit {

    AvailableTestList: Test[] = [];

    productGroupCode: string = '';
    BatchCode: string = '';

    constructor(
        private testService: TestService,
        private snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<TestAvailableForProductBoxComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.productGroupCode = data.productGroupCode;
        }
    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {

    }
    getComparaisonLQLabel(lq: EComparaisonLQ) {
        return StringConverter.getComparaisonLQName(lq)
    }

    search() {
        if (!this.BatchCode || this.BatchCode.length < 1) {
            return;
        }
        this.testService.getTestAvailableOnBatch(this.productGroupCode, this.BatchCode).subscribe(x => {
            this.AvailableTestList = x
        })
    }

    CanSave() {
        return this.AvailableTestList.length > 0;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (!this.CanSave())
            return;

        this.dialogRef.close(this.AvailableTestList);
    }
}
